import React from 'react';

// This component only renders a plain bar of a fixed length
function SeekbarRail() {
  return <div className="vp-seekbar-rail" />;
}

export default SeekbarRail;
